module.exports = __webpack_public_path__ + "img/phone-plus.07deb139.svg";